export default function convertCurrency(val) {
  let dollarBalance;
  if (val?.tradingAccountFrom?.currency && val.tradingAccountFrom.currency === "CENT") {
    dollarBalance = parseFloat(val.amount) / 100;
  } else {
    dollarBalance = parseFloat(val.amount);
  }
  return dollarBalance;
}